import scrollIntoView from 'scroll-into-view-if-needed';
import Constants from '../globals/Constants';
import MobileHelper from './MobileHelper';

let latestCommentScrollTimeoutId = -1;

const scrollCommentIntoView = (commentNode: HTMLElement, options?: { delay?: number, alignment?: ScrollLogicalPosition, scrollMode?: 'always'|'if-needed' }) => {
   options = options || {};
   options.delay = options.delay || 100;
   options.alignment = options.alignment || 'start';
   options.scrollMode = options.scrollMode || 'if-needed';
   const boundaryClassName = MobileHelper.isMobileWidth() ?
      Constants.mobileCommentContainerClassName :
      Constants.commentContainerClassName;

   clearTimeout(latestCommentScrollTimeoutId);

   const scroll = () => {
      scrollIntoView(commentNode, {
         behavior: 'smooth',
         block: options.alignment,
         scrollMode: options.scrollMode,
         boundary: document.getElementsByClassName(boundaryClassName)[0]
      });
   };

   latestCommentScrollTimeoutId = setTimeout(scroll, options.delay) as any;
};

export default {scrollCommentIntoView};
